import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useProductsContext } from "../../Contexts/SidebarContext";
import { NewMessageDialog } from "./NewMessageDialog";
import { NetworkManager } from "../../Components/NetworkManager";
import { CommonUtil } from "../../utils/CommonUtil";
import ToastManager from "../../Components/ToastManager";
import SearchBarWithButton from "../BroadcastFBManage/DMComponents/SearchBarWithButton";
import MessageList from "../BroadcastFBManage/DMComponents/MessageList";
import MessageTabs from "../BroadcastFBManage/DMComponents/MessageTabs";

interface Messages {
  id: number;
  messageTemplateName: string;
  headline: string;
  scheduledTime: string;
  image: string;
}
interface MarketingMessagesProps {
  handleBackToCampaigns: () => void;
}

const MarketingMessages: React.FC<MarketingMessagesProps> = ({
  handleBackToCampaigns,
}) => {
  const { sideBar } = useProductsContext();

  const [searchTerm, setSearchTerm] = useState("");
  const [editMessage, setEditMessage] = useState<any>(null);
  const [openMessageDialog, setOpenMessageDialog] = useState<any>(false);
  const [messages, setMessages] = useState<Messages[]>([]);
  const [selectedTab, setSelectedTab] = useState(0);

  const {
    facebook: { pageId },
  } = JSON.parse(localStorage.getItem("fbbPageDetail") || "{}");

  const { adAccountId } = JSON.parse(
    localStorage.getItem("fbbAdAccountDetail") || "{}"
  );

  const { messageCampaignId } = JSON.parse(
    localStorage.getItem("selectedCampaign") || "{}"
  );

  useEffect(() => {
    fetchMarketingMessages();
  }, []);

  const fetchMarketingMessages = () => {
    let pageDataReq = `pageId=${pageId}&adAccountId=${adAccountId}&messageCampaignId=${messageCampaignId}`;

    NetworkManager.sendJsonRequest(
      "broadcastMessageTemplates/getBroadcastTemplates",
      "",
      pageDataReq,
      "GET",
      true,
      onSuccessCall,
      onErrorCall
    );
  };

  const onSuccessCall = (data: any) => {
    const respData = CommonUtil.parseData(data);
    if (respData.statusCode === "BM0000") {
      const messagesList = respData?.broadcastMessageTemplateDetails;
      setMessages(messagesList);
    } else if (respData.statusCode !== "BM0000") {
      ToastManager.showToast("No messages are available.", "Error");
    }
  };
  const onErrorCall = () => {};

  const scheduledMessages = messages.filter(
    (message: any) => message.templateStatus === "Not Sent"
  );

  const filteredMessages = scheduledMessages.filter((message) =>
    message.messageTemplateName
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const pastMessages = messages.filter(
    (message: any) => message.templateStatus === "Sent"
  );
  const filteredPastMessages = pastMessages.filter((message) =>
    message.messageTemplateName
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleOpenMessageDialog = () => {
    setOpenMessageDialog(true);
    setEditMessage(null);
  };

  const handleEditMessage = (data: any) => {
    localStorage.setItem("selectedMessage", JSON.stringify(data));
    const messageDetails = JSON.parse(
      localStorage.getItem("selectedMessage") || "{}"
    );
    const messageTemplateId = messageDetails?.messageTemplateId;

    const params = `messageTemplateId=${messageTemplateId}`;

    NetworkManager.sendJsonRequest(
      "broadcastMessageTemplates/getBroadcastTemplateData",
      "",
      params,
      "GET",
      true,
      (response: any) => onEditSuccess(response, data),
      onEditError
    );
  };
  const onEditSuccess = (response: any, data: any) => {
    const respData = CommonUtil.parseData(response);
    if (respData.statusCode === "BM0000") {
      const templateDetails = respData.templateData.template;
      localStorage.setItem(
        "selectedMessageDetails",
        JSON.stringify(templateDetails)
      );
      setEditMessage({
        ...data,
        templateDetails,
      });
      setOpenMessageDialog(true);
    } else {
      ToastManager.showToast(
        respData.Message || "Failed to fetch message details.",
        "Error"
      );
    }
  };

  const onEditError = (err: any) => {
    ToastManager.showToast("Error fetching message details", "Error");
  };

  const handleSaveMessage = (newMessage: any) => {
    setMessages((prevMessages) => {
      const existsMessage = prevMessages.some(
        (message: any) =>
          message.messageTemplateId === newMessage.messageTemplateId
      );
      if (existsMessage) {
        return prevMessages.map((message: any) =>
          message.messageTemplateId === newMessage.messageTemplateId
            ? newMessage
            : message
        );
      } else {
        return [...prevMessages, newMessage];
      }
    });
  };
  return (
    <Box
      className="content-page"
      sx={{
        ml: sideBar ? "120px" : "120px",
        backgroundColor: "#fff",
        mr: 10,
      }}>
      <Box className="content">
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Button
              variant="outlined"
              sx={{ textTransform: "none", ml: 8 }}
              onClick={handleBackToCampaigns}>
              ← Back
            </Button>
          </Grid>
          <Grid item xs={8}>
            <Typography
              variant="h5"
              fontWeight="bold"
              gutterBottom
              sx={{ textAlign: "start", ml: 5 }}>
              Messages
            </Typography>
          </Grid>

          <Grid container justifyContent="center">
            <Grid item xs={12} md={10} lg={8}>
              <SearchBarWithButton
                placeholder="Search Message..."
                searchTerm={searchTerm}
                onSearchChange={setSearchTerm}
                onNew={handleOpenMessageDialog}
                newBtnLabel="+ New Message"
              />
            </Grid>
          </Grid>
          <Grid container ml={sideBar ? 20 : 22} mb={2}>
            <MessageTabs
              value={selectedTab}
              onChange={(e, val) => {
                setSelectedTab(val);
              }}
            />
          </Grid>
          {selectedTab === 0 && (
            <MessageList
              messages={filteredMessages}
              onEdit={handleEditMessage}
              emptyMessage="No scheduled messages"
            />
          )}
          {selectedTab === 1 && (
            <MessageList
              messages={filteredPastMessages}
              onEdit={undefined}
              emptyMessage="No past messages"
            />
          )}
        </Grid>
        <NewMessageDialog
          open={openMessageDialog}
          onClose={() => setOpenMessageDialog(false)}
          onSave={handleSaveMessage}
          editMessage={editMessage}
          fetchMarketingMessages={fetchMarketingMessages}
        />
      </Box>
    </Box>
  );
};
export default MarketingMessages;
